import { notificationApi } from '@/store/api/notification/notification.api';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeNotification } from '@/types/notification/types.notification';

export const writeNotification = (dispatch: TypeAppDispatch, notification: TypeNotification): void => {
    if (!notification || typeof notification.id !== 'string') return;
    dispatch(notificationApi.util.updateQueryData('listNotifications', undefined, (draft) => {
        const index = draft.items.findIndex((entry) => entry.id === notification.id);
        if (index === -1) {
            draft.items.unshift(notification);
            if (!notification.read) draft.unread += 1;
            return;
        }
        const was = draft.items[index];
        if (!was.read && notification.read) draft.unread = Math.max(0, draft.unread - 1);
        if (was.read && !notification.read) draft.unread += 1;
        draft.items[index] = notification;
    }));
};

export const dropNotification = (dispatch: TypeAppDispatch, id: string): void => {
    dispatch(notificationApi.util.updateQueryData('listNotifications', undefined, (draft) => {
        const gone = draft.items.find((entry) => entry.id === id);
        if (!gone) return;
        if (!gone.read) draft.unread = Math.max(0, draft.unread - 1);
        draft.items = draft.items.filter((entry) => entry.id !== id);
    }));
};
